import Api from './api';

const userLogsListRequest = (userId) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().get('/api/logs/' + userId, {
        headers: { Authorization: 'Bearer ' + access_token } ,
    })
}

const createUserLogRequest = (data) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().post('/api/logs/', data, { headers: { Authorization: 'Bearer ' + access_token } })
}

const deleteUserLogRequest = (id) => {
    const access_token = JSON.parse(localStorage.getItem("jwt"))
    return Api().delete('/api/log/' + id, { headers:
        {
            Authorization: 'Bearer ' + access_token,
            'Content-Type': 'application/x-www-form-urlencoded'
        }

    })
}


export default { userLogsListRequest, createUserLogRequest, deleteUserLogRequest }



// WEBPACK FOOTER //
// ./src/api/apiUserLogs.js